/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 基本设置
  Manage: () => import(/* webpackChunkName: "dict" */ '@/views/page/Product/Manage/index'), // 产品管理
  ProType: () => import(/* webpackChunkName: "dict" */ '@/views/page/Product/ProType/index'), // 产品类别管理
};

export const productRoute = [
  {
    path: '/Product',
    component: Layout,
    name: 'Product',
    isMenu: true,
    redirect: { name: 'ProManage' },
    meta: { title: '产品中心', icon: 'menu_chanpin' },
    children: [
      {
        path: 'Manage',
        name: 'ProManage',
        component: routes['Manage'],
        meta: { title: '产品管理'}
      },
      {
        path: 'ProType',
        name: 'ProType',
        component: routes['ProType'],
        meta: { title: '产品类别管理'}
      }
    ]
  }
];
